export default "__VITE_ASSET__ErUj10K2__"